// Lightweight dev-only logger.
// In production builds, these calls become no-ops and won't leak internals to the console.
const isDev = process.env.NODE_ENV === 'development';

export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logInfo = (...args) => {
  if (isDev) console.log(...args);
};
